import Swiper from 'swiper';
import { Navigation, Controller } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

/**
 * Class representing a car image carousel.
 * @class CarImageCarousel
 *
 * @param {HTMLElement} element - The parent element of the carousel
 */
class CarImageCarousel {
  constructor(element) {
    // elements
    this.element = element;
    const mainCarouselElement = this.element.querySelector('.swiper-car-carousel');
    const thumbnailCarouselElement = this.element.querySelector('.swiper-thumbnail');
    const fullscreenButtons = this.element.getElementsByClassName('carousel-fullscreen-button');
    const container = this.element.querySelector('.swiper-container');
    const firstSwiperSlideImage = mainCarouselElement.querySelectorAll('.swiper-slide img')[0];

    // Initialize both carousels
    this._thumbnailCarousel = new Swiper(thumbnailCarouselElement, this._thumbnailCarouselSettings);
    this._mainCarousel = new Swiper(mainCarouselElement, this._mainCarouselSettings);

    // Create control over the carousels, so that they will be in sync with each other
    this._mainCarousel.controller.control = this._thumbnailCarousel;
    this._thumbnailCarousel.controller.control = this._mainCarousel;

    // Initialize fullscreen button
    this._initializeFullscreenButtons(fullscreenButtons, container, this._thumbnailCarousel);

    // Remove loading property from the first slide to help reduce the LCP
    firstSwiperSlideImage.removeAttribute('loading');
  }

  /**
   * The settings for the main carousel.
   * @type {Object} - The settings for the main carousel.
   */
  _mainCarouselSettings = {
    spaceBetween: 10,
    watchSlidesProgress: true,
    //touchStartPreventDefault: false,
    passiveListeners: true,
    rewind: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    modules: [Navigation, Controller],
  };

  /**
   * The settings for the thumbnail carousel.
   * @type {Object} - The settings for the thumbnail carousel.
   */

  _thumbnailCarouselSettings = {
    slidesPerView: 3.5,
    spaceBetween: 10,
    centeredSlides: true,
    slideToClickedSlide: true,
    watchSlidesProgress: true,
    //touchStartPreventDefault: false,
    passiveListeners: true,
    lazyPreloadPrevNext: 1,
    breakpoints: {
      600: {
        slidesPerView: 4,
      },

      700: {
        slidesPerView: 6,
      },
      1076: {
        slidesPerView: 5.5,
      },
      1385: {
        slidesPerView: 6.5,
      },
    },
    modules: [Controller],
  };

  /**
   * Adds event listener to the fullscreen buttons that will toggle the fullscreen mode
   * and change the thumbnail carousel settings in fullscreen mode
   *
   * @param {Array} fullscreenButtons - The fullscreen buttons
   * @param {HTMLElement} container - The main container of the carousel
   * @param {HTMLElement} thumbnailCarousel - The thumbnail carousel
   */
  _initializeFullscreenButtons(fullscreenButtons, container, thumbnailCarousel) {
    Array.from(fullscreenButtons).forEach(button => {
      button.addEventListener('click', function () {
        container.classList.toggle('fullscreen');
        if (container.classList.contains('fullscreen')) {
          thumbnailCarousel.params.breakpoints = {
            600: {
              slidesPerView: 4,
            },

            700: {
              slidesPerView: 6,
            },
            1076: {
              slidesPerView: 7,
            },
            1385: {
              slidesPerView: 8,
            },
            1665: {
              slidesPerView: 10,
            },
          };
          thumbnailCarousel.update();
        }
      });
    });
  }

  /**
   * Initializes the car image carousel.
   * @returns {CarImageCarousel} - The car image carousel.
   */
  static init() {
    const carPageGrid = document.querySelector('.car-page__grid');

    if (carPageGrid) {
      return new CarImageCarousel(carPageGrid);
    }
  }
}

export default CarImageCarousel;
